export function highlightElement(elem, keywords, caseSensitive = false) {
  const flags = !caseSensitive ? 'gi' : 'g';
  keywords.sort((a, b) => b.length - a.length);
  const keywordRegex = RegExp(keywords.join('|'), flags);
  Array.from(elem.childNodes).forEach(child => {
    if (child.nodeType !== 3) { // not a text node
      highlightElement(child, keywords, caseSensitive);
    } else if (keywordRegex.test(child.textContent)) {
      const frag = document.createDocumentFragment();
      let lastIdx = 0;
      child.textContent.replace(keywordRegex, (match, idx) => {
        const part = document.createTextNode(child.textContent.slice(lastIdx, idx));
        const highlighted = document.createElement('mark');
        highlighted.textContent = match;
        frag.appendChild(part);
        frag.appendChild(highlighted);
        lastIdx = idx + match.length;
      });
      const end = document.createTextNode(child.textContent.slice(lastIdx));
      frag.appendChild(end);
      child.parentNode.replaceChild(frag, child);
    }
  });
}

function highlightEmail(str, searchText) {
  // Match pattern: email<mailto:email>
  const email = str.replace(
    /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})<mailto:\1>/g,
    '[$1](mailto:$1)'
  );
  const safeSearch = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`\\[([^\\]]*?)(${safeSearch})([^\\]]*?)\\]\\((mailto:[^\\)]+)\\)`, 'gi');
  return email.replace(regex, (match, before, found, after, mailto) =>
    `[${before}<mark>${found}</mark>${after}](${mailto})`
  );
}

export function highlightText(text, searchText) {
  const mailToRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})<mailto:\1>/g;
  if(typeof text === 'string' && text.match(mailToRegex))
  {
    return highlightEmail(text, searchText);
  } 
  const tempElement = document.createElement('div');
  tempElement.innerHTML = text;
  highlightElement(tempElement, searchText?.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').split(/\s+/));
  return tempElement.innerHTML;
}